import { ArrowRight, Clock, FileText, Shield } from "lucide-react";
import {
  PiCarDuotone,
  PiDeviceMobileDuotone,
  PiHandCoinsDuotone,
  PiShootingStarDuotone,
  PiSuitcaseRollingDuotone,
} from "react-icons/pi";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";

interface ServicoProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const servicos: ServicoProps[] = [
  {
    icon: <PiDeviceMobileDuotone className="w-full h-full text-n-green" />,
    title: "Cotação online rápida",
    description: "Orçamento facilitado via site, telefone ou WhatsApp.",
  },
  {
    icon: <Clock className="w-full h-full text-n-green" />,
    title: "Rastreamento em tempo real",
    description: "Acompanhe seu veículo durante todo o percurso.",
  },
  {
    icon: <Shield className="w-full h-full text-n-green" />,
    title: "Seguro abrangente",
    description: "Cobertura contra roubo, furto, acidentes e avarias.",
  },
  {
    icon: <FileText className="w-full h-full text-n-green" />,
    title: "Documentação simplificada",
    description:
      "Exigência apenas do CRLV Digital ou ATP-V em casos de transferência.",
  },
  {
    icon: <PiCarDuotone className="w-full h-full text-n-green" />,
    title: "Entrega flexível",
    description:
      "Não é necessária a presença do proprietário, basta um representante autorizado.",
  },
  {
    icon: <PiHandCoinsDuotone className="w-full h-full text-n-green" />,
    title: "Pagamentos seguros",
    description: "Pix, boleto, cartão de crédito ou transferência bancária.",
  },
  {
    icon: <PiShootingStarDuotone className="w-full h-full text-n-green" />,
    title: "Política de desistência justa",
    description: "Crédito disponível por até 12 meses.",
  },
  {
    icon: <PiSuitcaseRollingDuotone className="w-full h-full text-n-green" />,
    title: "Pertences pessoais no veículo",
    description:
      "Permitidos em condições específicas, com orientações claras para sua segurança.",
  },
  // {
  //   icon: (
  //     <PiClockCounterClockwiseDuotone className="w-full h-full text-n-green" />
  //   ),
  //   title: "Porta-a-porta",
  //   description:
  //     "Coleta e entrega do seu veículo no seu endereço de preferência.",
  // },
  // {
  //   icon: <PiShieldCheckDuotone className="w-full h-full text-n-green" />,
  //   title: "Pagamentos seguros",
  //   description: "Pix, boleto, cartão de crédito ou transferência bancária.",
  // },
  // {
  //   icon: <PiFilesDuotone className="w-full h-full text-n-green" />,
  //   title: "Política de desistência justa",
  //   description: "Crédito disponível por até 12 meses.",
  // },
  // {
  //   icon: <PiSuitcaseRollingDuotone className="w-full h-full text-n-green" />,
  //   title: "Pertences pessoais no veículo",
  //   description:
  //     "Permitidos em condições específicas, com orientações claras para sua segurança.",
  // },
];
export const ServicosSection = () => {
  return (
    <section className="py-10 md:py-24 bg-n-bg-1">
      <div className="container">
        <h2 className="text-center mb-12 text-3xl font-semibold text-n-green md:text-4xl lg:text-5xl">
          Serviços complementares
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {servicos.map((servico, index) => (
            <div
              key={index}
              className="bg-n-bg-2 rounded-xl p-6 2xl:h-[300px] lg:h-[280px] h-[150px] hover:scale-105 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="flex flex-col justify-between h-full">
                <div className="flex flex-col  gap-4">
                  <div className="lg:w-10 lg:h-10 h-6 w-6 transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                    {servico.icon}
                  </div>
                  <h3 className="text-n-green font-semibold 2xl:text-xl lg:text-lg text-md group-hover:text-n-primary transition-colors duration-300">
                    {servico.title}
                  </h3>
                </div>
                <p className="text-n-text-neutral 2xl:text-lg text-sm transition-colors duration-300">
                  {servico.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-n-text-neutral text-sm font-semibold mb-6">
            Na Nacional GO, cada detalhe foi pensado para garantir sua
            tranquilidade do início ao fim.
          </p>
          <Link to="/fazer-cotacao">
            <Button id="btn-fazer-cotacao">
              Agendar meu transporte agora
              <ArrowRight className="ml-2 " />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
